import { atom } from 'recoil';

type StatusType = 'idle' | 'loading' | 'success' | 'error';

export type EmailAtomType = {
  status: { send: StatusType };
  error: object;
}

export const emailAtom = atom<EmailAtomType>({
  key: 'emailAtom',
  default: {
    status: { send: 'idle' },
    error: {}
  },
});